
import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import Spinner from '../components/Spinner';


const StaffQuizScores: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [submissions, setSubmissions] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();


  const fetchScores = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/staff/quiz-submissions');
      setSubmissions(res.data || []);
    } catch (err: any) {
      console.error('Error loading quiz scores:', err);
      setError(err?.response?.data?.message || err?.message || 'Failed to load quiz scores');
    } finally {
      setLoading(false);
    }
  };

  // ...existing code...

  useEffect(() => {
    console.log('[StaffQuizScores] useEffect running, calling fetchScores');
    fetchScores();
  }, []);

  // Group by unique quizId and date
  const uniqueRows = React.useMemo(() => {
    const seen = new Set();
    return submissions.filter((sub) => {
      const key = `${sub.quiz?._id || sub.quiz}-${new Date(sub.createdAt).toISOString().split('T')[0]}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [submissions]);

  const handleRowClick = (sub: any) => {
    const quizId = sub.quiz?._id || sub.quiz;
    const date = new Date(sub.createdAt).toISOString().split('T')[0];
    navigate(`/staff/quiz-scores/${quizId}/${date}`);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, minHeight: '80vh' }}>
      <Button variant="outlined" sx={{ mb: 2 }} onClick={() => navigate(-1)}>
        Back
      </Button>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Student Quiz Scores
      </Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
          <Spinner />
        </Box>
      ) : error ? (
        <Paper sx={{ p: 3, color: 'error.main', background: '#fff0f0' }}>{error}</Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Quiz Title</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {uniqueRows.map((sub) => (
                <TableRow key={`${sub.quiz?._id || sub.quiz}-${new Date(sub.createdAt).toISOString().split('T')[0]}`} hover sx={{ cursor: 'pointer' }} onClick={() => handleRowClick(sub)}>
                  <TableCell>{sub.quiz?.title || 'N/A'}</TableCell>
                  <TableCell>{new Date(sub.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default StaffQuizScores;
